import { TicketPage } from '@ontruck/fe-alianza';
import { useParams } from 'react-router-dom';
export function TicketRouterPage({ config }) {
  const { id } = useParams();

  return <TicketPage config={config} ticketId={id} />;
}
